export const TIPOS_SERVICO = [
  { value: 'DESMONTAGEM', label: 'Desmontagem Industrial' },
  { value: 'GERENCIAMENTO_RESIDUOS', label: 'Gerenciamento de Resíduos' },
  { value: 'GERENCIAMENTO_MATERIAIS', label: 'Gerenciamento de Materiais' },
  { value: 'TRANSPORTE_RESIDUOS', label: 'Transporte de Resíduos' },
  { value: 'OUTROS', label: 'Outros' },
];

export function tipoServicoLabel(tipo) {
  return TIPOS_SERVICO.find((t) => t.value === tipo)?.label || tipo || '-';
}

export function exigeRastreabilidadeResiduos(tipo) {
  return tipo === 'GERENCIAMENTO_RESIDUOS' || tipo === 'TRANSPORTE_RESIDUOS';
}

export const STATUS_OS = {
  RASCUNHO: { label: 'Rascunho', color: 'default' },
  LIBERADA_INICIO: { label: 'Liberada para Início', color: 'info' },
  LIBERADA_FINAL: { label: 'Concluída/Liberada', color: 'success' },
  CANCELADA: { label: 'Cancelada', color: 'error' },
};

export function statusOSInfo(status) {
  return STATUS_OS[status] || { label: status || '-', color: 'default' };
}

// react-hook-form manda "" para <input type="date"> vazio, e o backend
// não consegue desserializar "" como LocalDate (400 Bad Request).
const CAMPOS_DATA_OS = ['dataEmissao', 'contratoDataAssinatura'];

export function normalizarDatasOS(payload) {
  const normalizado = { ...payload };
  CAMPOS_DATA_OS.forEach((campo) => {
    if (normalizado[campo] === '') {
      normalizado[campo] = null;
    }
  });
  return normalizado;
}
